import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import { FilterMatchMode, FilterService } from 'primereact/api'
import { Dropdown } from 'primereact/dropdown'
import ParentDataTable from '../../components/data-table/ParentDataTable'
import { ROUTES_PATH } from '../../utility/constants'
import BreadCrumbs from '../breadcrumb/Breadcrumb'
import TableDateInput from '../table-date-input/TableDateInput'
import { getStudentExam } from '../../store/builders/studentExam/studentExam.builder'
import { capitalizeFirstLetter, dynamicCustomFilter } from '../../utility/genricFunction'
import Loader from '../../components/loader/Loader'

const StudentExam = () => {
  const dispatch = useDispatch()

  const numbers = [
    { label: '10', value: 10 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
  ]
  const { studentResultData, loading } = useSelector((state) => state?.studentExam)
  const { user } = useSelector((state) => state.auth) || {}

  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)
  const [selectedValue, setSelectedValue] = useState(null)

  FilterService.register('dynamic_custom', (value, filter, filterMeta) => {
    return dynamicCustomFilter(value, filter, filterMeta?.matchMode || 'CONTAINS')
  })

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    courseName: { value: null, matchMode: 'dynamic_custom' },
    type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    facultyName: { value: null, matchMode: 'dynamic_custom' },
    resultStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
  })

  const [filteredData, setFilteredData] = useState([])
  const [filterNumber] = useState(false)

  const types = [
    { label: 'online exam', value: 'online_exam' },
    { label: 'offline exam', value: 'offline_exam' },
    { label: 'lecture', value: 'lecture' },
  ]

  const statuses = [
    { label: 'pass', value: 'pass' },
    { label: 'fail', value: 'fail' },
  ]

  const studentId = user?.result?.studentId

  useEffect(() => {
    dispatch(getStudentExam({ studentId }))
  }, [])

  useEffect(() => {
    setFilteredData(studentResultData)
  }, [studentResultData])

  // useEffect(() => {
  //   if (studentResultData.length !== filteredData.length) {
  //     setfilterNumber(true)
  //   } else {
  //     setfilterNumber(false)
  //   }
  // }, [studentResultData, filteredData])

  const onFilter = (event) => {
    const newFilters = { ...filters, ...event.filters }
    setFilters(newFilters)
    const filtered = filterData(studentResultData, newFilters)
    setFilteredData(filtered)
  }

  const filterData = (data, filters) => {
    return data.filter((item) => {
      return Object.keys(filters).every((key) => {
        if (!filters[key].value) return true
        const value = item[key]
        const filterValue = filters[key].value.toLowerCase().trim()
        return value && value.toString().toLowerCase().includes(filterValue)
      })
    })
  }

  const nameBody = (studentResultData) => {
    const representative = capitalizeFirstLetter(studentResultData.resultStatus)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const statusRowFilterTemplate = (options) => {
    const onDropdownChange = (e) => {
      setSelectedValue(e.value)
      options.filterApplyCallback(e.value)
    }
    return (
      <Dropdown
        value={selectedValue}
        options={statuses}
        onChange={onDropdownChange}
        // itemTemplate={statusItemTemplate}
        placeholder='All'
        className='p-column-filter'
        optionLabel='label'
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }
  const typeRowFilterTemplate = (options) => {
    const onDropdownChange = (e) => {
      setSelectedValue(e.value)
      options.filterApplyCallback(e.value)
    }
    return (
      <Dropdown
        value={selectedValue}
        options={types}
        onChange={onDropdownChange}
        // itemTemplate={statusItemTemplate}
        placeholder='All'
        className='p-column-filter'
        optionLabel='label'
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const columns = [
    {
      sortable: true,
      field: 'courseName',
      header: 'Course',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by course...',
      style: { minWidth: '12rem' },
    },
    {
      sortable: true,
      field: 'type',
      header: 'Type',
      showFilterMenu: false,
      filterMenuStyle: { width: '14rem' },
      style: { minWidth: '12rem' },
      filter: true,
      filterElement: typeRowFilterTemplate,
    },
    {
      sortable: true,
      field: 'date',
      header: 'Date',
      style: { minWidth: '12rem' },
      filterElement: TableDateInput,
      filter: true,
      filterPlaceholder: 'Search by date...',
    },
    {
      sortable: true,
      field: 'facultyName',
      header: 'Checked By',
      showFilterMenu: false,
      filterMenuStyle: { width: '14rem' },
      style: { minWidth: '12rem' },
      filter: true,
      filterPlaceholder: 'Search by faculty...',
    },
    {
      sortable: true,
      field: 'marks',
      header: 'Marks',
      showFilterMenu: false,
      filterMenuStyle: { width: '14rem' },
      style: { minWidth: '12rem' },
      filter: false,
    },
    {
      sortable: true,
      field: 'resultStatus',
      header: 'Result',
      showFilterMenu: false,
      filterMenuStyle: { width: '14rem' },
      style: { minWidth: '12rem' },
      body: nameBody,
      filter: true,
      filterElement: statusRowFilterTemplate,
    },
  ]

  const breadCrumbsArr = [
    {
      title: 'Exam',
      link: null,
    },
    {
      title: 'Dashboard',
      link: ROUTES_PATH.STUDENT_DASHBOARD,
    },
    {
      title: 'Exam',
      link: ROUTES_PATH.STUDENT_EXAM,
    },
  ]

  return (
    <>
      {/* <div className={`telephonic-container flex flex-column`}> */}
      {loading && <Loader loading={loading} />}
      {<Loader loading={loading} /> && <div className={`course-list`}>
        <div className='filter-bar-wraper'>
          <div className='subheader'>
            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
          </div>
        </div>

        <div className='group-parent'>
          <div className='frame-wrapper'>
            <div className='course-list-wrapper'>
              <b className='course-list1'>Exam History</b>
            </div>
          </div>
          <div className='flex page-drop-div'>
            <p className='page-sidetext'>Show</p>
            <PageDropdown
              options={numbers}
              selectedValue={selectedNumber}
              onChange={(e) => setSelectedNumber(e.value)}
              className='w-full md:w-14rem small-dropdown'
            />
            <p className='page-endtext'>entries</p>
          </div>

          <div className='table-card'>
            <ParentDataTable
              value={filteredData}
              rows={filterNumber ? filteredData.length : selectedNumber}
              filters={filters}
              // loading={loading}
              // globalFilterFields={['name', 'country.name', 'representative.name', 'status']}
              columns={columns}
              onFilter={onFilter}
            />
          </div>
        </div>

        {/* <BranchTable /> */}
        {/* </div> */}
      </div>}
    </>
  )
}

export default StudentExam
